var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("img", {
    staticClass: "flag",
    attrs: { src: _vm.imgPath, alt: _vm.countryCode }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }